// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import LoginFormController from "./login_form_controller"
import UserSearchController from "./admin/users/user_search_controller";
import ProjectSearchController from "./admin/projects/project_search_controller";
import ProjectUsersController from "./admin/projects/project_users_controller";
import ThumbnailUploadController from "./admin/projects/thumbnail_upload_controller";
import PointCloudUploadController from "./admin/point_clouds/upload_controller";
import PointCloudInlineEditController from "./admin/point_clouds/inline_edit_controller";
import UserFormController from "./admin/users/user_form_controller"
import ConfirmController from "./confirm_controller"

application.register("login-form", LoginFormController)
application.register("user-search", UserSearchController)
application.register("project-search", ProjectSearchController)
application.register("project-users", ProjectUsersController)
application.register("thumbnail-upload", ThumbnailUploadController)
application.register("point-cloud-upload", PointCloudUploadController)
application.register("point-cloud-inline-edit", PointCloudInlineEditController)
application.register("user-form", UserFormController)
application.register("confirm", ConfirmController)
